import { defineStore } from 'pinia';
import http from '../api/httpRequest.js'

export default defineStore('serviceStore', {
	state: () => {
		return {
			services: [], // 数组用于展示，防止更新时不刷新
			serviceMap: new Map() // map用于查询，提高查询效率
		}
	},
	actions: {
		setServices(services) {
			this.services = services;
			this.serviceMap.clear();
			services.forEach(s => {
				// 适配后端数据结构，确保有 name 字段用于显示
				if (!s.name && s.nickName) {
					s.name = s.nickName;
				}
				if (!s.name && s.userName) {
					s.name = s.userName;
				}
				this.serviceMap.set(s.id, s)
			})
		},
		clear() {
			this.services = [];
			this.serviceMap.clear();
		},
		loadService() {
			return new Promise((resolve, reject) => {
				http({
					url: '/user/private-chat-enabled-users',
					method: 'GET'
				}).then((services) => {
					// 确保 services 是数组
					if (!Array.isArray(services)) {
						services = [];
					}
					this.setServices(services);
					resolve(services);
				}).catch((err) => {
					reject(err);
				})
			});
		}
	},
	getters: {
		findService: (state) => (userId) => {
			return state.serviceMap.get(userId);
		}
	}
});
